/**
 * @ngdoc controllers
 * @memberof mercury.modules.time
 * @name TimeRosterShiftReportCtrl
 */
angular.module('mercury.modules.time.roster')
.controller('TimeRosterShiftReportCtrl', ["$filter", "$q", "reporttime", "$scope", "TimeClock", "TimeRosteredShifts", "title", "shiftHelpers", function($filter, $q, reporttime, $scope, TimeClock, TimeRosteredShifts, title, shiftHelpers) {
  title.set('Staff Roster');
  reporttime.defaultType = 'week';

  $scope.allOpen = false;

  $scope.loading = $q.all({
    clocks: TimeClock.getAllActiveAndClockedIn(reporttime.start(), reporttime.end()),
    rosteredShifts: TimeRosteredShifts.getAll(reporttime.start(), reporttime.end())
  });

  $scope.loading.then(function(result) {
    var rosteredShifts = result.rosteredShifts;

    // Build a list of paired clocks and rostered shifts.
    var clockRosteredShiftPairs = [];
    var effectiveClocks = TimeClock.effectiveClocks(result.clocks, reporttime.start(), reporttime.end());
    angular.forEach(effectiveClocks, function(clock) {
      var matchingRosteredShifts = $filter('filter')(result.rosteredShifts, function(rosteredShift) {
        return rosteredShift.staffMemberId == clock.staffMemberId &&
          moment(clock.clockinTime).mStartOf('day').format() == moment(rosteredShift.clockinTime).mStartOf('day').format();
      });

      if (matchingRosteredShifts.length === 0) {
        // No matching rostered shift for this clockin
        clockRosteredShiftPairs.push({
          clockin: clock,
          roleId: clock.roleId,
          roleName: clock.roleName,
          staffId: clock.staffMemberId,
          staffName: clock.staffMemberFirstName + ' ' + (clock.staffMemberLastName || '')
        });
      } else {
        // Remove the rostered shift from the rostered shifts list so we can append the unmatched rostered shifts
        var firstMatch = matchingRosteredShifts[0];
        angular.forEach(rosteredShifts, function(rosteredShift, index) {
          if (rosteredShift.id == firstMatch.id) {
            rosteredShifts.splice(index, 1);
          }
        });

        clockRosteredShiftPairs.push({
          clockin: clock,
          rosteredShift: firstMatch,
          roleId: clock.roleId,
          roleName: clock.roleName,
          staffId: clock.staffMemberId,
          staffName: clock.staffMemberFirstName + ' '  + (clock.staffMemberLastName || '')
        });
      }
    });

    // Any remaining rosters had no matched clocks so append them.
    angular.forEach(rosteredShifts, function(rosteredShift) {
      clockRosteredShiftPairs.push({
        rosteredShift: rosteredShift,
        roleId: rosteredShift.roleId,
        roleName: rosteredShift.roleName,
        staffId: rosteredShift.staffMemberId,
        staffName: rosteredShift.staffMemberFirstName + ' ' + (rosteredShift.staffMemberLastName || '')
      });
    });

    $scope.reportTotalRosterLength = 0;
    $scope.reportTotalClockLength = 0;
    $scope.reportTotalLengthDifference = 0;
    $scope.reportTotalCostDifference = 0;

    var roles = [];

    // First group the pairs by the roleId
    var rolePairGroupings = $filter('groupby')(clockRosteredShiftPairs, 'roleId');
    angular.forEach(rolePairGroupings, function(rolePairs) {
      var roleGroup = {
        name: rolePairs[0].roleName,
        staff: [],
        totalRosterLength: 0,
        totalClockLength: 0,
        totalLengthDifference: 0,
        totalCostDifference: 0
      };

      // Secondly group the pairs by the staffId
      var staffPairGrouping = $filter('groupby')(rolePairs, 'staffId');
      angular.forEach(staffPairGrouping, function(staffPairs) {
        var staffGroup = {
          name: staffPairs[0].staffName,
          shifts: [],
          totalRosterLength: 0,
          totalClockLength: 0,
          totalLengthDifference: 0,
          totalCostDifference: 0
        };

        angular.forEach(staffPairs, function(shift) {
          var dayStart = null;
          var clockinLabel = 'No Clock In';
          var clockinLength = 0;
          var clockinCost = 0;
          if (shift.clockin) {
            clockinLabel = moment(shift.clockin.clockinTime).format('h:mma') + ' - ' + moment(shift.clockin.clockoutTime).format('h:mma');
            clockinLength = moment(shift.clockin.clockoutTime).diff(shift.clockin.clockinTime, 'hours', true);
            if (shift.clockin.rules !== null && shift.clockin.rules.length > 0) {
              clockinCost = clockinLength * shift.clockin.adjustedHourlyRate;
            } else {
              clockinCost = clockinLength * shift.clockin.hourlyRate;
            }
            dayStart = moment(shift.clockin.clockinTime).mStartOf('day').format();
          }

          var rosteredShiftLabel = 'Not Rostered';
          var rosteredShiftLength = 0;
          var rosteredShiftCost = 0;
          if (shift.rosteredShift) {
            rosteredShiftLabel = moment(shift.rosteredShift.clockinTime).format('h:mma') + ' - ' + moment(shift.rosteredShift.clockoutTime).format('h:mma');
            rosteredShiftLength = moment(shift.rosteredShift.clockoutTime).diff(shift.rosteredShift.clockinTime, 'hours', true);

            // Calculate the total unpaid break duration using the helper function
            var totalUnpaidBreakDuration = shiftHelpers.calculateTotalUnpaidBreakDuration(shift.rosteredShift);

            // Remove the total unpaid break duration from the total rostered shift length
            rosteredShiftLength = rosteredShiftLength >= totalUnpaidBreakDuration ? rosteredShiftLength -= totalUnpaidBreakDuration : rosteredShiftLength;

            if (shift.rosteredShift.rules.length) {
              rosteredShiftCost = rosteredShiftLength * shift.rosteredShift.adjustedHourlyRate;
            } else {
              rosteredShiftCost = rosteredShiftLength * shift.rosteredShift.hourlyRate;
            }
            dayStart = moment(shift.rosteredShift.clockinTime).mStartOf('day').format();
          }

          var differenceLength = clockinLength - rosteredShiftLength;
          var differenceCost = clockinCost - rosteredShiftCost;

          staffGroup.shifts.push({
            day: moment(dayStart).format('dddd Do MMMM'),
            rosterLabel: rosteredShiftLabel,
            clockinLabel: clockinLabel,
            differenceLength: differenceLength,
            differenceCost: differenceCost
          });

          staffGroup.totalRosterLength += rosteredShiftLength;
          staffGroup.totalClockLength += clockinLength;
          staffGroup.totalLengthDifference += differenceLength;
          staffGroup.totalCostDifference += differenceCost;

          roleGroup.totalRosterLength += rosteredShiftLength;
          roleGroup.totalClockLength += clockinLength;
          roleGroup.totalLengthDifference += differenceLength;
          roleGroup.totalCostDifference += differenceCost;

          $scope.reportTotalRosterLength += rosteredShiftLength;
          $scope.reportTotalClockLength += clockinLength;
          $scope.reportTotalLengthDifference += differenceLength;
          $scope.reportTotalCostDifference += differenceCost;
        });

        roleGroup.staff.push(staffGroup);
      });

      roles.push(roleGroup);
    });

    $scope.roles = roles;
  });

  $scope.showAll = function() {
    $scope.allOpen = !$scope.allOpen;

    angular.forEach($scope.roles, function(role) {
      angular.forEach(role.staff, function(staff) {
        staff.open = $scope.allOpen;
      });
    });
  };
}]);
